<!-- eslint-disable vue/no-mutating-props -->
<template>
  <DialogPrime
    v-model:visible="localVisible"
    :closable="false"
    :close-on-escape="false"
    modal
    header="Alternative Unit of Measure"
    :style="{ width: '720px', minWidth: '600px' }"
  >
    <DataTable :value="rows" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="300px">
      <Column field="numerator" header-class="bg-light text-center" :header-style="colW(130)" :body-style="colW(130, true)">
        <template #header>
          Numerator <span class="exclamation-mark-error-tab">*</span>
        </template>
        <template #body="{ data }">
          <InputNumber
            :model-value="toNum(data.numerator)"
            size="small"
            :min="0"
            :use-grouping="false"
            :max-fraction-digits="3"
            :class="{ 'p-invalid': isCellInvalid(data, 'numerator') }"
            :disabled="readonly || isNumeratorDisabled(data)"
            fluid
            @update:model-value="(val) => { data.numerator = val !== null ? String(val) : '' }"
          />
        </template>
      </Column>
      <Column field="alternative_unit_of_measure" header="Alternative UoM" header-class="bg-light" :header-style="colW(160)" :body-style="colW(160, true)">
        <template #body="{ data }">
          <InputText v-model="data.alternative_unit_of_measure" size="small" disabled fluid />
        </template>
      </Column>
      <Column header="" header-class="bg-light text-center" body-class="text-center" :header-style="colW(50)" :body-style="colW(50)">
        <template #body>
          <span class="fw-semibold">=</span>
        </template>
      </Column>
      <Column header="Base Unit of Measure" header-class="bg-light" :header-style="colW(180)" :body-style="colW(180, true)">
        <template #body>
          <InputText :value="baseUom" size="small" disabled fluid />
        </template>
      </Column>
      <Column field="denumerator" header-class="bg-light text-center" :header-style="colW(130)" :body-style="colW(130, true)">
        <template #header>
          Denumerator <span class="exclamation-mark-error-tab">*</span>
        </template>
        <template #body="{ data }">
          <InputNumber
            :model-value="toNum(data.denumerator)"
            size="small"
            :min="0"
            :use-grouping="false"
            :max-fraction-digits="3"
            :disabled="readonly || isDenumeratorDisabled"
            :class="{ 'p-invalid': isCellInvalid(data, 'denumerator') }"
            fluid
            @update:model-value="(val) => { data.denumerator = val !== null ? String(val) : '' }"
          />
        </template>
      </Column>
      <Column field="source_field" header="Source Field" header-class="bg-light" :header-style="colW(180)" :body-style="colW(180, true)">
        <template #body="{ data }">
          <InputText v-model="data.source_field" size="small" disabled fluid />
        </template>
      </Column>
      <template #empty>
        <div class="text-muted text-center small py-3">No alternative unit of measure.</div>
      </template>
    </DataTable>

    <template #footer>
      <ButtonPrime label="Close" @click="tryClose" />
    </template>
  </DialogPrime>
</template>

<script>
// Popup Alternative UoM FORM02 (clone AlternativeUnitPopup.vue): baris = `cat_emcr_alternative_uoms` item terpilih (array yang
// SAMA dengan yang disimpan), diisi/disinkronkan config `alt_uom` lewat kerangka New_CataloguerTab.js. Baris pertama = Base UoM
// ("unit of measurement"). Yang bisa diedit tergantung tombol pembuka (`openBy` = source_field): dibuka dari Base UoM ->
// Denumerator semua baris + Numerator baris Base; dibuka dari Sales Unit dst. -> Numerator baris itu saja.
export default {
  name: "NewAlternativeUomPopup",
  props: {
    rows: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
    openBy: { type: String, default: "" },
    // Mode lihat-saja: semua input terkunci, Close tanpa validasi.
    readonly: { type: Boolean, default: false },
    baseSourceField: { type: String, default: "unit of measurement" }
  },
  emits: ["update:visible"],
  data() {
    return { isRowSubmitted: false };
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); }
    },
    baseUom() {
      return this.rows?.[0]?.alternative_unit_of_measure || "";
    },
    isDenumeratorDisabled() {
      return this.openBy !== this.baseSourceField;
    }
  },
  watch: {
    visible(val) {
      if (val) this.isRowSubmitted = false;
    }
  },
  methods: {
    toNum(str) {
      const n = parseFloat(str);
      return isNaN(n) ? null : n;
    },
    hasVal(str) {
      if (str === null || str === undefined || str === "") return false;
      const n = parseFloat(str);
      return !isNaN(n) && n >= 0;
    },
    tryClose() {
      const incomplete = !this.readonly && (this.rows || []).some((row) => !this.hasVal(row.numerator) || !this.hasVal(row.denumerator));
      if (incomplete) {
        this.isRowSubmitted = true;
        this.$toast?.add({
          severity: "warn",
          summary: "Incomplete Data",
          detail: "Complete the Numerator and Denumerator of all rows before closing.",
          life: 3000
        });
        return;
      }
      this.isRowSubmitted = false;
      this.$emit("update:visible", false);
    },
    colW(width, body = false) {
      return {
        width: `${width}px`,
        minWidth: `${width}px`,
        maxWidth: `${width}px`,
        paddingLeft: body ? "10px" : undefined
      };
    },
    // Merah kalau kosong dan (Close sudah dicoba ATAU sel ditandai error oleh validasi Save -- row.rowErrors).
    isCellInvalid(data, column) {
      return (this.isRowSubmitted || !!data?.rowErrors?.[column]) && !this.hasVal(data?.[column]);
    },
    isNumeratorDisabled(data) {
      return data.source_field !== this.openBy;
    }
  }
};
</script>
